import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { useEffect } from 'react';
import { GetAllRequestAtKycUpload } from 'API/Approval/api';
import { Button, Typography } from '@mui/material';
import DocumentModal from './DocumentModel';
import { Stack } from '@mui/system';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import RejectReasonDialog from './RejectReasonDIalog';
// import ImageModal from '../Approval/Components/ImageModal';



// function createData(name, code, population, size) {
//   const density = population / size;
//   return { name, code, population, size, density };
// }

// const rows = [
//   createData('India', 'IN', 1324171354, 3287263),
//   createData('China', 'CN', 1403500365, 9596961),
//   createData('Italy', 'IT', 60483973, 301340),
//   createData('United States', 'US', 327167434, 9833520),
//   createData('Canada', 'CA', 37602103, 9984670),
//   createData('Australia', 'AU', 25475400, 7692024),
//   createData('Germany', 'DE', 83019200, 357578),
//   createData('Ireland', 'IE', 4857000, 70273),
//   createData('Mexico', 'MX', 126577691, 1972550),
//   createData('Japan', 'JP', 126317000, 377973),
//   createData('France', 'FR', 67022000, 640679),
//   createData('United Kingdom', 'GB', 67545757, 242495),
//   createData('Russia', 'RU', 146793744, 17098246),
//   createData('Nigeria', 'NG', 200962417, 923768),
//   createData('Brazil', 'BR', 210147125, 8515767),

// ];

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return `${formattedDate}`;
}

export default function KycTable(props) {
  const [page, setPage] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false)
  const [openRejectReason, setOpenRejectReason] = React.useState(false)
  const [RejectData, setRejectData] = useState(null)

  const handleClickOpen = (row) => {
    setOpen(true);
    setData(row);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const handleRejectReasonOpen = (row) => {
    setOpenRejectReason(true);
    setRejectData(row);

  }

  const handleRejectReasonClose = () => {
    setOpenRejectReason(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [rows, setRows] = useState(null)
  const [FilteredData, setFilteredData] = useState(null)

  useEffect(() => {
    GetAllRequestAtKycUpload(setRows, setIsLoading, page + 1, props.type)

  }, [])


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    GetAllRequestAtKycUpload(setRows, setIsLoading, newPage + 1, props.type)
  };

  // console.log("filtered",FilteredData);


  useEffect(() => {
    if (rows && rows.data && Array.isArray(rows.data)) {
      // console.log("rows",rows);

      if (!props.filter || (props.filter.name === "" && props.filter.agcode === "")) {
        if (props.type === "pending") {
          let filter = rows.data.filter(row => row.product_availed && row.flow === 2 && !row.kyc_reupload && (!row.rejected_by_ops || row.rejected_by_ops === false))
          setFilteredData(filter)
        }
        else if (props.type === "rejected") {
          let filter = rows.data.filter(row => row.product_availed && row.flow === 2 && row.kyc_reupload && row.rejected_by_ops)
          setFilteredData(filter)
        }
        else {
          let filter = rows.data.filter(row => row.product_availed && row.flow === 2 && row.kyc_reupload)
          setFilteredData(filter)
        }
      }
      else {
        if (props.type === "pending") {
          let filter = rows.data.filter(row => ((row.product_availed && row.flow === 2 && !row.kyc_reupload && (!row.rejected_by_ops || row.rejected_by_ops === false)) && (Object.values(row).some(value =>
            String(value).toLocaleLowerCase().includes(props.filter.name) && String(value).toLocaleLowerCase().includes(props.filter.agcode)
          ))))
          setFilteredData(filter)
        }
        else if (props.type === "rejected") {
          let filter = rows.data.filter(row => ((row.product_availed && row.flow === 2 && !row.kyc_reupload && row.rejected_by_ops) && (Object.values(row).some(value =>
            String(value).toLocaleLowerCase().includes(props.filter.name) && String(value).toLocaleLowerCase().includes(props.filter.agcode)
          ))))
          setFilteredData(filter)
        }
        else {
          let filter = rows.data.filter(row => ((row.product_availed && row.flow === 2 && row.kyc_reupload) && (Object.values(row).some(value =>
            String(value).toLocaleLowerCase().includes(props.filter.name) && String(value).toLocaleLowerCase().includes(props.filter.agcode)
          ))))
          setFilteredData(filter)
        }
      }



    }
  }, [rows, props.type, props.filter])



  return (
    isLoading ?
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      :
      <div style={{ width: '100%' ,padding:0}}>
        <RejectReasonDialog open={openRejectReason} handleClose={handleRejectReasonClose} data={RejectData} />
        <DocumentModal type={props.type} open={open} data={data} handleClose={handleClose} />
        <Paper sx={{ width: '100%', overflow: 'hidden' ,padding:0}}>
          {
            FilteredData && FilteredData.length > 0 ?
              <TableContainer sx={{ maxHeight: "100%", maxWidth: '100%' ,padding:0}}>
                <Table stickyHeader aria-label="sticky table" size='small'>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#F8FAFC", color: "#592375" }}>

                      <TableCell
                        align='center'
                        sx={{ fontWeight: 700, color: "#592375" }}
                      >
                        Name
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{ fontWeight: 700, color: "#592375" }}
                      >
                        Agent Code
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{ fontWeight: 700, color: "#592375" }}
                      >
                        Product
                      </TableCell>

                      {
                        <TableCell
                          align='center'
                          sx={{ fontWeight: 700, color: "#592375" }}
                        >
                          Date
                        </TableCell>

                      }

                      <TableCell
                        align='center'
                        sx={{ fontWeight: 700, color: "#592375" }}
                      >
                        Action
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 700, color: "#592375" }}
                      >
                        {props.type === 'rejected' ? "Rejected reason" : ""}
                      </TableCell>

                    </TableRow>
                  </TableHead>


                  <TableBody sx={{ width: '100%' }}>

                    {FilteredData &&
                      FilteredData
                        .map((row, index) => {
                          return (
                            row.product_availed && row.flow === 2 ?
                              <TableRow hover role="checkbox" sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }} tabIndex={-1} key={row.code}>
                                <TableCell align='center'>{row.agent_name}</TableCell>
                                <TableCell align='center'>{row.user_code}</TableCell>
                                <TableCell align='center'>{row.product_name}</TableCell>
                                {

                                  <TableCell align='center'>{formatDate(row.updated_at)}</TableCell>


                                }
                                <TableCell align='center'><Button variant='contained' sx={{
                                  backgroundColor: "#592375",
                                  color: "#fff",
                                  borderRadius: "10px",
                                  '&:hover': {
                                    backgroundColor: "#688B3A",
                                    color: "#fff",
                                    borderRadius: "10px",
                                  },
                                }} onClick={() => handleClickOpen(row)}>View</Button></TableCell>
                                <TableCell align='center'>
                                  {props.type === 'rejected' ? <Button variant='text' onClick={() => handleRejectReasonOpen(row)}>view</Button> : null}
                                </TableCell>
                              </TableRow>
                              :
                              null
                          );
                        })}
                  </TableBody>




                </Table>
              </TableContainer>
              :
              // <TableBody sx={{justifyContent:'center'}}>
              //   <TableRow>
              <Stack justifyContent="center" alignItems="center">
                <Typography mt={1} variant="subtitle1" color="grey">No record found</Typography>
              </Stack>
          }

          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={rows ? rows.total : 0}
            rowsPerPage={rows ? rows.limit : 10}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
  );
}
